"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.BatteryStatusTypes = void 0;
var types_devices_1 = require("@ledgerhq/types-devices");
var errors_1 = require("@ledgerhq/errors");
var BatteryStatusTypes;
(function (BatteryStatusTypes) {
    BatteryStatusTypes[BatteryStatusTypes["BATTERY_PERCENTAGE"] = 0] = "BATTERY_PERCENTAGE";
    BatteryStatusTypes[BatteryStatusTypes["BATTERY_VOLTAGE"] = 1] = "BATTERY_VOLTAGE";
    BatteryStatusTypes[BatteryStatusTypes["BATTERY_TEMPERATURE"] = 2] = "BATTERY_TEMPERATURE";
    BatteryStatusTypes[BatteryStatusTypes["BATTERY_CURRENT"] = 3] = "BATTERY_CURRENT";
    BatteryStatusTypes[BatteryStatusTypes["BATTERY_FLAGS"] = 4] = "BATTERY_FLAGS";
})(BatteryStatusTypes = exports.BatteryStatusTypes || (exports.BatteryStatusTypes = {}));
// Nb USB and BLE masks not used by implementation since we have
// them from the model.
var FlagMasks;
(function (FlagMasks) {
    FlagMasks[FlagMasks["CHARGING"] = 1] = "CHARGING";
    FlagMasks[FlagMasks["USB"] = 2] = "USB";
    FlagMasks[FlagMasks["USB_POWERED"] = 8] = "USB_POWERED";
    FlagMasks[FlagMasks["BLE"] = 4] = "BLE";
    FlagMasks[FlagMasks["ISSUE_BATTERY"] = 128] = "ISSUE_BATTERY";
    FlagMasks[FlagMasks["ISSUE_CHARGING"] = 16] = "ISSUE_CHARGING";
    FlagMasks[FlagMasks["ISSUE_TEMPERATURE"] = 32] = "ISSUE_TEMPERATURE";
})(FlagMasks || (FlagMasks = {}));
var getBatteryStatus = function (transport, p2) {
    if (p2 === void 0) { p2 = BatteryStatusTypes.BATTERY_FLAGS; }
    return __awaiter(void 0, void 0, void 0, function () {
        var res, status, temp, flags, chargingUSB, chargingQi;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, transport.send(0xe0, 0x10, 0x00, p2)];
                case 1:
                    res = _a.sent();
                    status = res.readUInt16BE(res.length - 2);
                    if (status === errors_1.StatusCodes.OK) {
                        switch (p2) {
                            case BatteryStatusTypes.BATTERY_PERCENTAGE: {
                                temp = res.readUInt8(0);
                                return [2 /*return*/, temp > 100 ? -1 : temp];
                            }
                            case BatteryStatusTypes.BATTERY_VOLTAGE:
                                return [2 /*return*/, res.readUInt16BE(0)];
                            case BatteryStatusTypes.BATTERY_TEMPERATURE:
                            case BatteryStatusTypes.BATTERY_CURRENT:
                                // Nb turn the usigned byte into a signed int to cover
                                // negative values. Two's compliment.
                                return [2 /*return*/, (res.readUInt8() << 24) >> 24];
                            case BatteryStatusTypes.BATTERY_FLAGS: {
                                flags = res.readUInt16BE(2);
                                chargingUSB = !!(flags & FlagMasks.USB_POWERED);
                                chargingQi = !chargingUSB && !!(flags & FlagMasks.CHARGING);
                                return [2 /*return*/, {
                                        charging: chargingQi
                                            ? types_devices_1.ChargingModes.QI
                                            : chargingUSB
                                                ? types_devices_1.ChargingModes.USB
                                                : types_devices_1.ChargingModes.NONE,
                                        issueCharging: !!(flags & FlagMasks.ISSUE_CHARGING),
                                        issueTemperature: !!(flags & FlagMasks.ISSUE_TEMPERATURE),
                                        issueBattery: !!(flags & FlagMasks.ISSUE_BATTERY)
                                    }];
                            }
                        }
                    }
                    throw new errors_1.TransportStatusError(status);
            }
        });
    });
};
exports["default"] = getBatteryStatus;
//# sourceMappingURL=getBatteryStatus.js.map